export default __webpack_public_path__ + "d0069ea221990f89934ec863ed6e22f6.png";